interface ProcessingRef {
  current: boolean;
}

export const runSkipTokenVerification = async (
  processingRef: ProcessingRef,
  setIsProcessing: (isProcessing: boolean) => void,
  operation: () => Promise<void>
) => {
  if (processingRef.current) {
    return;
  }

  processingRef.current = true;
  setIsProcessing(true);

  try {
    await operation();
  } finally {
    processingRef.current = false;
    setIsProcessing(false);
  }
};
